import { put, call, select } from "redux-saga/effects"
import { handleFetchTags, getRecentTagCombos } from "./tag_sagas"
import { handleFetchGoals } from "./goal_sagas"
import { handleGetProfile } from "./profile_sagas"
import { computeRunningTimeEntries } from "./time_entries_sagas"
import { setBootstrapped } from "../action_creators"
import socket from "../../api/socket_client"
import { getProfile } from "../selectors"
import { sitka } from "../store"
import GA from "react-ga"

export function* handleBootstrap() {
    // console.log("*** BOOT STRAP ***") // eslint-disable-line no-console
    //profile
    yield call(handleGetProfile)
    const profile = yield select(getProfile)

    // only fetch goals, tags, time entries if verified
    if (profile.email.verified) {
        // update google analytics userid
        GA.set({ userId: profile.email.address })

        // tags
        yield call(handleFetchTags, {})
        yield call(getRecentTagCombos)

        // goals
        yield call(handleFetchGoals, {})

        // running time entries
        yield call(computeRunningTimeEntries)

        // get connected apps
        const { googleCalendarConfigs, zoomConfigs } = sitka.getModules()
        yield call(googleCalendarConfigs.handleFetchGoogleCalendarConfigs)
        yield call(zoomConfigs.handleFetchZoomConfigs)
    }

    socket.initialize()
    yield put(setBootstrapped(true))
}

export function* handleOnboardingBootstrap() {
    yield call(handleGetProfile)
    socket.initialize()
    yield put(setBootstrapped(true))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/bootstrap_sagas.js